<template>
    <div>
        <div class="breadcrumbs">
            <div class="col-sm-4">
                <div class="page-header float-left">
                    <div class="page-title">
                        <h1>직원 정보 등록</h1>
                    </div>
                </div>
            </div>            
        </div>        
        <b-container fluid class="animated fadeIn">
            <div class="card">
                <div class="card-header">
                    <strong class="card-title">직원 엑셀 등록</strong>
                </div>
                <b-card-body>
                    <div class="mb-1 mt-2 float-left">
                        <b-button class="mb-2" size="" variant="primary" @click="goBack">뒤로가기</b-button>
                    </div>
                    <div class="ml-3 float-right">
                        <b-button class="mb-2" size="" variant="primary" href="/static/doc/직원등록양식.xlsx">다운로드</b-button>
                        <b-form-file v-model="file" ref="excel_file" :state="Boolean(file)" placeholder="엑셀파일등록" @change="_change" accept=".xls, .xlsx"></b-form-file> 
                    </div>                   
                    <b-table 
                        show-empty
                        empty-text="조회된 내용이 없습니다."
                        empty-filtered-text="조회된 내용이 없습니다."
                        fixed="fixed"
                        responsive="sm" 
                        :small="true"                          
                        :striped="false" 
                        :bordered="true"  
                        hover                                 
                        :items="items" 
                        :fields="fields">                                                                                   
                    </b-table>
                    <div class="mb-1 mt-2 float-right" v-if="items.length > 0">
                        <b-button class="mb-2" size="" variant="primary" @click="addEmployees">직원 등록</b-button>
                    </div>                    
                </b-card-body>
            </div>            
        </b-container>    
    </div>
</template>
<script>
import {employees} from '../data/table.js'
import employeeApi from '../api/employee'
import ResultMessage from '../data/resultMessage'
import {mapGetters} from 'vuex'
import _ from 'lodash'
import XLSX from 'xlsx';

const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x,i) => ({name:XLSX.utils.encode_col(i), key:i}));

export default {
    name: 'regEmployees',
    data() {
        return {
            fields: employees.fields,
            items: [],            
            currentPage: 1,
            perPage: 5,
            totalRows: 0,
            filter: null,
            department: null,
            isModify: false,
            state: {
                tickets:[{name:"test"}],
                headers:["Test header"]
            },
            file: null
        }
    },
    computed: mapGetters({
        userAccount: 'userAccount/userAccount'                
    }),
    methods: {
        goBack: function() {
            this.$router.go(-1);
        },
        addEmployees: function() {
            if(this.items == null || this.items.length < 1) return;
            employeeApi.addEmployees(this.items);
        },       
        _change(evt) {
            const files = evt.target.files;            
            if(files == false && files[0] == false) 
                this.$refs.excel_file.reset();
            if(files && files[0])
                this._file(files[0]);
		},
        _file(file) {
			/* Boilerplate to set up FileReader */
			const reader = new FileReader();
			reader.onload = (e) => {
				/* Parse data */
				const bstr = e.target.result;
				const wb = XLSX.read(bstr, {type:'binary', raw: true});
				/* Get first worksheet */
				const wsname = wb.SheetNames[0];
				const ws = wb.Sheets[wsname];
				/* Convert array of arrays */
                const data = XLSX.utils.sheet_to_json(ws, {header:1, blankrows: false});
                
                /* Update state */
                if(this.makeItems(data.slice(1)) == false) {                    
                    alert('필수 항목을 확인 해 주세요');
                    this.file = null;
                    this.itmes = [];
                    this.$refs.excel_file.reset();
                    return;
                }                    				
			};
            reader.readAsBinaryString(file);
            
        },
        makeItems: function(data) {
            if(data == false) return false;
                        
            const corpNo = this.userAccount.corpNo;
            const vendorNo = this.userAccount.vendorNo;
            const deptNo = this.$route.query.deptNo;
            const tempItems = [];
            for(let i = 0; i < data.length; i++) {
                let item = data[i];
                if(!item[1] || !item[2]) {                    
                    return false;
                }                
                let jsonItem = {};
                jsonItem.deptNo = deptNo;
                jsonItem.corpNo = corpNo;
                jsonItem.vendorNo = vendorNo;
                jsonItem.state = 10931;
                jsonItem.name = item[0];
                jsonItem.positionName = item[1];
                jsonItem.phoneNo = item[2];
                jsonItem.carDesc = item[3];
                let limitOption = {};
                limitOption.overLimitPermitYN = item[4];
                limitOption.useLimitCnt = item[5];
                limitOption.useLimitAmount = item[6];
                jsonItem.limitOption = limitOption;
                jsonItem.memo = item[7];
                jsonItem.subMemo = item[8];
                tempItems.push(jsonItem);                
            }
            this.items = tempItems;
            return true;
        },
        addEmployees: function(items) {
            let resultMessage = new ResultMessage();                

            employeeApi.addEmployees(this.items).then(response => {                    
                alert('등록 되었습니다.');                
            }).catch(error => {
                resultMessage.buildErrorMessage(error);
                alert(resultMessage.message);
            })
        }
    },
    mounted: function() {
        // 최초 로딩 데이터 조회
        // this.departmentList();
    }

}
</script>




// WEBPACK FOOTER //
// src/components/RegEmployees.vue